module.exports = __webpack_public_path__ + "static/img/voicetrain.e5d1af1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/voicetrain.jpg
// module id = 1492
// module chunks = 0